/**
 * Version 0.0.0
 * StepIndicator Widget
 * A statefull StepIndicator component that supports the api:
 * next() to complete a step and set the next step as current
 * render(steps) to reapply both steps and their states
 *
 * Author: Oded Sagir
 * @param  Object require -for adding dependencies
 * @return Object         -Class Object
 */
define(function(require) {
    'use strict';

    var Logger = require("logger");
    var $ = require('jquery');
    var _ = require('underscore');
    var Backbone = require('backbone');
    var Marionette = require('marionette');
    var template = require('ui/stepIndicator/templates/stepIndicator.tmpl');
      

    var StepIndicator= Marionette.ItemView.extend({
        template:template,
        withUIComponents:true,
        /**
         * set and render the stepIndicator
         * @param  {string} el    a css selector of where we'd like to embed our stepIndicator, defaults to ".step-indicator"
         * @param  {Object} steps either an array of string to show as steps, or an array of objects {text:...,state:...}
         */
        initialize: function(options){
          this.$el= $(options.el || ".step-indicator");
          this.model = new Backbone.Model({
              permutation: options.permutation || StepIndicator.PERMUTATION.A,
              steps: this._setModelSteps(options.steps)
          });          
        },
        onRender: function(){
            if (!this.$el.hasClass("step-indicator"))
            {
                this.$el.addClass("step-indicator");
            }
          this.$el.addClass(this.model.get('permutation'));
        },
        /**
         * will find the current step mark it as completed and set the next one to current
         */
        next: function() {
          var steps= this.model.get('steps');
          for(var i=0; steps.length; i++){
            var stepData= steps[i];
            if(stepData.state === StepIndicator.STATE.CURRENT){
              var nextStep= Math.min(i+1, steps.length - 1);

              stepData.state= StepIndicator.STATE.COMPLETED;
              stepData.isCurrent= false;
              steps[nextStep].state= StepIndicator.STATE.CURRENT;
              steps[nextStep].isCurrent= true;
              this.render();
              return;
            }
          }
        },
        _setModelSteps: function (steps) {
            return _.map(steps,function(step){
                return {
                    isCurrent: step.state === StepIndicator.STATE.CURRENT,
                    state: step.state,
                    text: step.text
                };
            });
        },
        updateSteps: function(stepIndicatorOptions){
            this.model.set("steps", this._setModelSteps(stepIndicatorOptions.steps));
            this.render();
        }
    });
     
    StepIndicator.STATE= {
        NOT_COMPLETED: "not-completed",
        CURRENT: "current",
        COMPLETED: "completed"
    }; 

    StepIndicator.PERMUTATION= {
        A: "permutation-a",
        B: "permutation-b",
        C: "permutation-c",
        D: "permutation-d",
        E: "permutation-e",
        F: "permutation-f",
        G: "permutation-g"
    };
    return StepIndicator;
});